// extracted by mini-css-extract-plugin
export var deleteModal = "_h4-0";